import { SchemaFieldMeta } from './types';
import {
  FieldHeader,
  FieldPropHeader,
  FieldsTable,
} from './SchemaEntityRelationsUI';
import { FieldClass } from '../../../../utils/apollo/graphqlSchema';
import { useMemo } from 'react';
import FieldRowDisplay from './FieldRowDisplay';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  fields: SchemaFieldMeta[];
  tableNameFunc: (tableKey: string) => string;
  expanded: boolean;
}

const fieldClassSortOrder = (cls: FieldClass) => {
  switch (cls) {
    case FieldClass.Event:
      return 1;
    case FieldClass.Subject:
      return 2;
    case FieldClass.Temporal:
      return 3;
    case FieldClass.Basic:
      return 4;
    default:
      throw new UnreachableCaseError(cls);
  }
};

const ViewFieldsTable = ({ fields, tableNameFunc, expanded }: IProps) => {
  const filteredFields = useMemo(() => {
    return expanded
      ? [...fields]
      : fields.filter(
          (field) =>
            field.fieldClass === FieldClass.Event ||
            field.fieldClass === FieldClass.Subject,
        );
  }, [expanded, fields]);
  const sortedFields = useMemo(
    () =>
      filteredFields.sort(
        (a, b) =>
          fieldClassSortOrder(a.fieldClass) - fieldClassSortOrder(b.fieldClass),
      ),
    [filteredFields],
  );
  if (sortedFields.length === 0) {
    return null;
  }
  return (
    <FieldsTable>
      <FieldHeader>
        <FieldPropHeader $widthPercent={36}>Column</FieldPropHeader>
        <FieldPropHeader $widthPercent={36}>Name</FieldPropHeader>
        <FieldPropHeader $widthPercent={20}>Type</FieldPropHeader>
        <FieldPropHeader $widthPercent={8}></FieldPropHeader>
      </FieldHeader>
      {sortedFields.map((f) => (
        <FieldRowDisplay
          key={f.column + '-view'}
          field={f}
          tableNameFunc={tableNameFunc}
        />
      ))}
    </FieldsTable>
  );
};

export default ViewFieldsTable;
